 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "vendors." + {"0":"b56eed1b6270e19c0ef4","1":"9aee01fb29964e73b598","2":"f5373d69668bb87bdd4c","3":"99969aa6f94fbf2a1561","4":"f1268792a9b0233393bd","5":"1c9642c62ccb475d3116","6":"54a5cf19dd41ad65ef6f","7":"113a9f431f7e07d0bdd4","vendors~Comment~ShareComment":"34ee0d20fb2b82db3973","vendors~Comment~Survey":"3b7a10504aa365ed9efa","vendors~Comment":"6ba45c5520dfef5412af","Comment":"21959edab72787efd6bf","AccountOpening":"0b59044700050a8df9b5","BackTopBottom":"c3b6f32fa2395d671406","CallupVideoAppHead":"873add403bd77a897551","Caption":"43ed624e6fa7ffee8736","Copyright":"9f41b861b9f5daae95ae","DataBox":"aceafef7bcc8411f7b2e","HomeFooter":"286bb43509e74eeb79d7","Hongbao":"6f65ad191aa64873800c","Img":"762e6d79ae40bcfac601","LivePlayer":"ceb27dd08aef4c8a273e","LoginDialog":"90a21afd516d6d1cc163","MoreTabs":"ecf9a209a2287256a7ea","Nav":"7897d4bb75c0650d0828","NormalCaption":"da549313b497f2020521","Offline":"b5544ea34c70ece4fcf4","QQShare":"66ac08674a1967e47ebe","Tip":"a40bb8a620e58b514ad6","ViewMoreLink":"a8095818066455bf53fd","WxLaunchApp":"8fdd10f47400d797bb9e","vendors~Atlas~FiveNavPic~FourNavPic~InformationFlow~MdBanner~ThreeNavPic":"ddb2d04d5fc970537c83","Atlas":"1342b7b3dbb8bb0e46d8","FiveNavPic":"bff5573cc8354f14aaf0","FourNavPic":"130ca9ab0d03f41c105d","ThreeNavPic":"f17380a2ad97ac80f2f7","vendors~BigImage~NewsStream~NoImage~OneImage~Stick~ThreeImage~TwoImage":"7932f045705316dbee02","BigImage":"f96d03c87d729f4b8bda","NoImage":"9f0ada7b5be35e6a0cff","OneImage":"f24b66ef1ab0c464f5ac","Stick":"4b5174169a5612d37ba6","ThreeImage":"47f2e1289c7446974c14","TwoImage":"a381e59e05d5d134352f","vendors~NewsStream":"13044a9f4ecf2019ba32","vendors~BigImg~BigTopic~BottomSlides~BrowserGuideLayer~CallupHead~IndexSlides~InformationFlow~MarkTa~e0be143a":"0148b5ab2961448ca0f4","vendors~Player":"4336fb18a0cc45b7d58e","BrowserGuideLayer":"0788d1a929c8ff2deddf","CallupHead":"ce25585e0bf4ab03c151","MarkTabs":"bc9f7416f29f2b2df62f","WXGuideLayer":"9c6d2925c4a4659f5ec7","MdBanner":"f89e7f4f66fc78c75467","vendors~BigImg~BigTopic~InformationFlow~SingleTitle~SlideImg~TitleImg~TwoImg":"01fdc570cd2f687be631","BigImg":"6466515efb66112f33b4","SingleTitle":"53743aa2bc359347c38b","SlideImg":"bc137595ea26dccd657a","TwoImg":"ea0f3b79220067408d20","vendors~BigTopic~InformationFlow~TitleImg":"c77115c81cc831ee35a5","InformationFlow":"e31dd929996642c2f0b1","BigTopic":"402823f62e29cc8a2c13","TitleImg":"b5247b6989914a80e4ef","vendors~BottomSlides~IndexSlides~NormalSlides~ShareSlides~Slides~UpgradeBottomSlides":"b75ae7e761bb1d74b20f","BottomSlides":"3e98d28fdd7c5ee22bd1","IndexSlides":"384c6174cfafef3024cb","vendors~UpgradeBottomSlides":"95fa27b269758017eafc","vendors~ShareComment":"1d9cc7a79f2f95928b09","vendors~Survey":"67e14bb49006b74a797d","NormalSlides":"1b90d6be8cebb52e6fcd","ShareSlides":"7645492a021c7132d0ef","Slides":"d4b4dd3826099186af97","vendors~NormalTabs":"4b5e072d3a575b9d8c33","vendors~SimpleGuideLayer":"8e4622b3d5e4d65ce8c8","vendors~SlidesTabs":"e019a227e943f76306f9"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				if (script.src.indexOf(window.location.origin + '/') !== 0) {
 					script.crossOrigin = "anonymous";
 				}
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://x2.ifengimg.com/fe/shank/channel/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
